import { render, staticRenderFns } from "./funcModelBox.vue?vue&type=template&id=8b2ae944&scoped=true&"
import script from "./funcModelBox.vue?vue&type=script&lang=js&"
export * from "./funcModelBox.vue?vue&type=script&lang=js&"
import style0 from "./funcModelBox.vue?vue&type=style&index=0&id=8b2ae944&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b2ae944",
  null
  
)

export default component.exports